import React from 'react';
import { Waypoint } from 'react-waypoint';

import ProductShortInfo from '../product-short-info/ProductShortInfo';

import useStyles from './styles';

const GeneralActivitiesList = ({
  activities,
  selectProduct,
  initialSelectedCurrency,
  page,
  perPage,
  fetchData,
}) => {
  const classes = useStyles();

  if (!activities?.length) return null;

  return (
    <div className={classes.wrapper}>
      {activities.map((item, index) => (
        <div key={item.id} className={classes.item}>
          <div>
            <ProductShortInfo
              item={item}
              initialSelectedCurrency={initialSelectedCurrency}
              isPrices={true}
              isRightArrow={true}
              selectProduct={selectProduct}
            />
          </div>
          {(page < perPage) && (index === activities.length - 2) && (
            <Waypoint onEnter={() => fetchData(page + 1)} />
          )}
        </div>
      ))}
      <div className={classes.afterElement}>{''}</div>
      <div className={classes.afterElement}>{''}</div>
    </div>
  );
};

export default GeneralActivitiesList;
